export class LocalStore<T> {
  value = $state<T>() as T;
  #key = '';

  get key() {
    return this.#key;
  }

  constructor(key: string, value: T) {
    this.#key = key;
    this.value = value;

    const item = localStorage.getItem(key);
    if (item) this.value = this.deserialize(item);

    $effect.root(() => {
      $effect(() => {
        localStorage.setItem(this.key, this.serialize(this.value));
      });
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      return () => {};
    });
  }

  serialize(value: T): string {
    return JSON.stringify(value);
  }

  deserialize(item: string): T {
    return JSON.parse(item) as T;
  }
}

export function localStore<T>(key: string, value: T) {
  return new LocalStore(key, value);
}
